<template>
  <div ref="container" style="height: 100%; overflow: hidden"></div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

export default defineComponent({
  name: 'JSONEdit',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const editorInstance = ref<JSONEditor>();
    const container = ref<HTMLDivElement>();

    onMounted(() => {
      if (container.value) {
        editorInstance.value = new JSONEditor(container.value, {
          mode: 'tree',
          onChangeJSON: val => {
            emit('update:value', val);
          },
        });
        editorInstance.value.set(props.value);
      }
    });

    onBeforeUnmount(() => {
      if (editorInstance.value) {
        editorInstance.value.destroy();
      }
    });

    return {
      container,
    };
  },
});
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
